<div class="facility-list">
  <button
    *ngFor="let facility of filteredFacilities"
    type="button"
    class="facility-item"
    [class.selected]="isFacilitySelected(facility)"
    (click)="onFacilityClick(facility)">
    <div class="facility-item__top-row">
      <mat-icon class="facility-item__icon">local_hospital</mat-icon>
      <span *ngIf="getFacilityRole(facility) === 'hub'" class="facility-item__role-chip facility-item__role-chip--hub">Hub</span>
      <span *ngIf="getFacilityRole(facility) === 'spoke'" class="facility-item__role-chip facility-item__role-chip--spoke">Spoke</span>
    </div>
    <div class="facility-item__name">{{ facility.name }}</div>
    <div class="facility-item__meta">
      <span *ngIf="facility.address" class="facility-item__meta-row">
        <mat-icon class="facility-item__meta-icon">location_on</mat-icon>{{ facility.address }}
      </span>
      <span *ngIf="facility.phoneNumber" class="facility-item__meta-row">
        <mat-icon class="facility-item__meta-icon">phone</mat-icon>{{ facility.phoneNumber }}
      </span>
      <span *ngIf="facility.emailAddress" class="facility-item__meta-row">
        <mat-icon class="facility-item__meta-icon">email</mat-icon>{{ facility.emailAddress }}
      </span>
      <span *ngIf="facility.id" class="facility-item__meta-row facility-item__meta-id">
        ID: {{ facility.id }} / {{ getFacilityDisplayName(facility) }}
      </span>
    </div>
  </button>
</div>
